module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fb-Ga-Ha-Ia-Ga.3bb362fd.png";